export default "__VITE_ASSET__C12Ugyqp__"